import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Close: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        width="2"
        height="20"
        transform="matrix(0.706658 -0.707555 0.706658 0.707555 4 5.41516)"
        fill={color}
      />
      <rect
        width="2"
        height="20"
        transform="matrix(0.706658 0.707555 -0.706658 0.707555 18.14 4.00513)"
        fill={color}
      />
    </svg>
  );
};

export default Close;
